const V = {
  name: "Hourglass",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 0H4V2H6V7C6 9.08689 7.06288 10.9232 8.68065 11.9964C7.06919 13.0718 6 14.9138 6 17V22H4V24H20V22H18V17C18 14.9131 16.9371 13.0768 15.3193 12.0036C16.9308 10.9282 18 9.08622 18 7V2H20V0ZM8 7V2H16V7C16 8.63876 15.0081 10.0574 13.5992 10.6738L13 10.936V13.0755L13.6011 13.337C15.018 13.9534 16 15.3609 16 17V18.2671C13.4814 17.017 10.5186 17.017 8 18.2672V17C8 15.3612 8.99186 13.9426 10.4008 13.3262L11 13.064V10.9245L10.3989 10.663C8.98196 10.0466 8 8.63906 8 7ZM8 20.5662L8.39862 20.3271C10.6154 18.997 13.3848 18.997 15.6016 20.3271L16 20.5661V22H8V20.5662Z" fill="currentColor"/>
</svg>
  `
};
export {
  V as Hourglass
};
